import { Switch } from '@headlessui/react';
import React, { useState } from 'react';
import { TopicStyles } from '../mixins/mixins';
import {
	StyleDropdownMenu,
	StyleSlider,
	StyleToggle
} from '../components/common';
import { SelectedBookmarks } from '../mixins/optionsValues';

export const BookmarksStyle = ({
	style,
	setStyle
}: {
	style: TopicStyles;
	setStyle: (style: TopicStyles) => void;
}) => {
	return (
		<div className="grid grid-cols-2 lg:grid-cols-3 justify-items-center gap-4">
			<StyleToggle
				key={'black_and_white'}
				style={style}
				styleObj={'bookmarkStyle'}
				parentStyle={style.bookmarkStyle}
				styleKey={'blackAndWhite'}
				name={'Black and white'}
				optionState={style.bookmarkStyle.blackAndWhite}
				setStyle={setStyle}
			/>

			<StyleToggle
				key={'open_new_tab'}
				style={style}
				styleObj={'bookmarkStyle'}
				parentStyle={style.bookmarkStyle}
				styleKey={'openNewTab'}
				name={'Open new tab'}
				optionState={style.bookmarkStyle.openNewTab}
				setStyle={setStyle}
			/>

			<StyleToggle
				key={'square'}
				style={style}
				styleObj={'bookmarkStyle'}
				parentStyle={style.bookmarkStyle}
				styleKey={'square'}
				name={'Square'}
				optionState={style.bookmarkStyle.square}
				setStyle={setStyle}
			/>

			<StyleDropdownMenu
				key={'selected_bookmarks'}
				name={'Selected Bookmarks'}
				options={[
					{
						name: 'Chrome Bookmarks',
						value: SelectedBookmarks.CHROME_BOOKMAKRS
					},
					{ name: 'Topic Default', value: SelectedBookmarks.TOPIC_DEFAULT },
					{ name: 'Top visited', value: SelectedBookmarks.TOP_VISITED },
					{ name: 'User Bookmarks', value: SelectedBookmarks.USER_BOOKMAKRS }
				]}
				optionState={style.bookmarkStyle.selectedBookmarks}
				handleChange={(value: any) => {
					setStyle({
						...style,
						bookmarkStyle: {
							...style.bookmarkStyle,
							['selectedBookmarks']: value
						}
					});
				}}
			/>

			<StyleSlider
				key={'gap-range'}
				id={'gap-range'}
				name={'Gap'}
				initialValue={style.bookmarkStyle.gap}
				minValue={'40'}
				maxValue={'70'}
				step={'1'}
				handleChange={({ value }: { value: any }) => {
					setStyle({
						...style,
						bookmarkStyle: { ...style.bookmarkStyle, ['gap']: value }
					});
				}}
			/>

			<StyleSlider
				key={'size-range'}
				id={'size-range'}
				name={'Size'}
				initialValue={style.bookmarkStyle.size}
				minValue={'4'}
				maxValue={'24'}
				step={'1'}
				handleChange={({ value }: { value: any }) => {
					setStyle({
						...style,
						bookmarkStyle: { ...style.bookmarkStyle, ['size']: value }
					});
				}}
			/>
		</div>
	);
};
